import { defineMessages } from 'react-intl'

const messages = {
  title: defineMessages({
    default: {
      id: 'appPage.ownEveryMile.title.default',
      defaultMessage: 'Own \nEvery Workout',
    },
    run: {
      id: 'appPage.ownEveryMile.title.run',
      defaultMessage: 'Own \nEvery Mile',
    },
    walk: {
      id: 'appPage.ownEveryMile.title.walk',
      defaultMessage: 'Own \nEvery Mile',
    },
    hike: {
      id: 'appPage.ownEveryMile.title.hike',
      defaultMessage: 'Own \nEvery Trail',
    },
    ride: {
      id: 'appPage.ownEveryMile.title.ride',
      defaultMessage: 'Own \nEvery Ride',
    },
  }),
  caption: defineMessages({
    default: {
      id: 'appPage.ownEveryMile.caption.default',
      defaultMessage: 'Get the UA MapMyFitness mobile app to track gym workouts, runs, and go further. Know your distance, pace, calorie burn, elevation, and more.',
    },
    run: {
      id: 'appPage.ownEveryMile.caption.run',
      defaultMessage: 'Get the UA MapMyRun mobile app to track runs and go further. Know your distance, pace, calorie burn, elevation, and more.',
    },
    walk: {
      id: 'appPage.ownEveryMile.caption.walk',
      defaultMessage: 'Get the UA MapMyWalk mobile app to track walks and go further. Know your distance, pace, calorie burn, elevation, and more.',
    },
    hike: {
      id: 'appPage.ownEveryMile.caption.hike',
      defaultMessage: 'Get the UA MapMyHike mobile app to track hikes and go further. Know your distance, pace, calorie burn, elevation, and more.',
    },
    ride: {
      id: 'appPage.ownEveryMile.caption.ride',
      defaultMessage: 'Get the UA MapMyRide mobile app to track rides and go further. Know your distance, speed, calorie burn, elevation, and more.',
    },
  }),
}

export default messages
